<div class="header" *ngIf="label">
    <fui-input-label [title]="label" [i18nParams]="i18nParams"
                     [valued]="true" [hovered]="hovered"></fui-input-label>
</div>
<div class="main">
    <ng-content></ng-content>
</div>
